import '@content/foundations/src/index'
import asWebComponent from '../../../asWebComponent'
import HeroHome from './MgmHero'

export default asWebComponent(HeroHome, 'nb-mgm-hero', ['data'])
